var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segments in_segment"},_vm._l((_vm.field_names),function(field_name,index){return _c('LabelInputItem',{key:field_name+'card_vertical_main',staticClass:"ui segment",class:{
            blue: field_name == 'consignee_company_name',
            green: field_name == 'sender_company_name',
            'no top border': index == 0,
        },style:({
            padding: !_vm.is_can_update_field(field_name) ? '0' : ''
        }),attrs:{"core_waybill":_vm.core_waybill,"field_name":field_name,"is_fluid":true,"is_hidden_segment_border":true,"is_dont_hide_content":_vm.is_in_scanner_modal}})}))}
var staticRenderFns = []

export { render, staticRenderFns }